import { Component } from '@angular/core';

import '../styles.sass';

@Component({
	selector: 	'my-app',
	template: 	require('./AppComponent.html'),
})
export class AppComponent {
	private module: string;
	private menuStatus: boolean;
	constructor() {
		this.module = 'services';
	}
	ngOnInit() {
	}
}


// WEBPACK FOOTER //
// ./src/services/AppComponent.ts